import { selector } from 'lib/selectors';
import { userAdapter, Apps } from './helpers';
import { currentOrganizationSelector } from 'domain/organization/organizationPureSelector';

const env = (state) => state.env;
export const buildSelector = selector(env, (e) => e.get('build'));
export const roleSelector = selector(env, (e) => e.get('role'));
export const roleModificatorsSelector = selector(env, (e) => e.get('roleModificators'));
export const isAuthorizedSelector = selector(roleSelector, (r) => Boolean(r));
export const tokenSelector = selector(env, (e) => e.get('dokkaToken'));
export const sagaDataLoadingSelector = selector(env, (e) => e.get('isSagaDataLoading'));

export const organizationUserIdSelector = selector(env, (e) => e.get('organizationId'));
export const organizationIdSelector = selector(
  organizationUserIdSelector,
  currentOrganizationSelector,
  (mainId, tempId) => tempId || mainId,
);

export const organizationNameSelector = selector(env, (e) => e.get('organizationName'));
export const navigationSelector = selector(env, (e) => e.get('navigation'));
export const backSearchUrlSelector = selector(env, (e) => e.get('backSearchUrl'));
export const persistedBackUrlSelector = selector(env, (e) => e.get('persistedBackUrl'));
export const linkedPanelWidthSelector = selector(env, (d) => d.get('linkedSidebarWidth'));
export const documentViewSelector = selector(env, (d) => d.get('view'));
export const paymentViewSelector = selector(env, (d) => d.get('paymentView'));
export const userIdSelector = selector(env, (e) => e.userId);
export const userNamesSelector = selector(env, (e) => ({
  firstName: e.firstName,
  lastName: e.lastName,
}));

export const isAdminSelector = selector(env, (e) => e.superUser);
export const isDokkaSupportSelector = selector(env, (e) => e.isDokkaSupport);

export const rtlEnable = selector(env, (e) => e.get('rtl'));
export const localeSelector = selector(env, (e) => {
  const locale = e.get('locale');
  return locale === 'uk' ? 'en' : locale;
});
export const realLocaleSelector = selector(env, (e) => e.get('locale'));
export const newChatFlowSelector = selector(env, (e) => e.get('newChatFlow'));
export const loadingSelector = selector(env, (e) => Boolean(e.loading));

export const chatUserSelector = selector(env, (e) => e.chatUser);
export const chatTokenSelector = selector(env, (e) => e.chatToken);

export const userSelector = selector(env, userAdapter);
export const isExpiredSelector = selector(env, (e) => e.isExpired);
export const userGUIDSelector = selector(env, (e) => e.userGUID);
export const appStatusesSelector = selector(env, (e) => e.appStatuses);
export const userFeaturesSelector = selector(env, (e) => e.features);
export const cognitoUsernameSelector = selector(env, (e) => e.cognitoUsername);
export const isBetaUserSelector = selector(env, (e) => e.beta);
export const isSmartlookRecordingSelector = selector(env, (e) => e.isSmartlookRecording);

export const userProfileSelector = selector(env, (e) => ({
  id: e.userGUID,
  first_name: e.firstName,
  last_name: e.lastName,
  email: e.userId,
  phone: e.phone,
  pic: e.picture,
  role: e.role,
  title: e.title,
  username: e.chatUser,
}));

export const hasUserRequireDataSelector = selector(
  tokenSelector,
  userGUIDSelector,
  (token, userGUID) => !!token === !!userGUID,
);

export const helpdeskLinkSelector = selector(env, (e) => e.helpdeskLink);

export const isAllowFreshdeskSelector = selector(env, (e) => e.allowFreshdesk);

export const workSpaceTypeSelector = selector(env, (e) => e.workSpace);
export const organizationBotSelector = selector(env, (e) => e.organizationBot);

export const errorSelector = selector(env, (e) => e.get('error'));
export const cameFromToApproveCategorySelector = selector(
  navigationSelector,
  (navigation) => navigation.getIn(['search', 'params', 'category1'], '').toString() === '46',
); // 46 === To Approve category

export const getConnectionHealthSelector = selector(env, (e) => e.get('connectionHealth'));
export const appsSelector = selector(env, (e) => e.get('apps'));

export const payModuleCompaniesContextSelector = selector(
  appsSelector,
  (apps) => apps.getIn([Apps.PAY, 'companiesContext']) || [],
);

export const payModuleCompanyPermissionsSelector = selector(env, (e) => e.payModuleCompanyPermissions);
export const payModuleAccountIdSelector = selector(
  payModuleCompanyPermissionsSelector,
  (list) => list.first()?.get('accountId') ?? '',
);
export const canManagePaymentProviderSelector = (accountId) =>
  selector(payModuleCompanyPermissionsSelector, (accounts) => {
    const account = accounts.find((acc) => acc.get('accountId') === accountId);
    if (!account) return false;
    return account.get('isController') || account.get('isOwner');
  });
export const isPayModuleCompanyPermissionsLoadedSelector = selector(env, (e) =>
  e.get('isPayModuleCompanyPermissionsLoaded'),
);

export const hasAnyPermissionsForCompanyPayModuleSelector = selector(payModuleCompanyPermissionsSelector, (list) =>
  list.some(
    (permissions) => permissions.get('isOwner') || permissions.get('isController') || permissions.get('isApprover'),
  ),
);
